export const initialState = {
    user: null,
    company: null,
    cart: { items: [] },
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'COMPANY_LOADED':
            return {
                ...state,
                company: action.payload,
            };

        case 'USER_LOADED':
            return {
                ...state,
                user: action.payload,
            };

        case 'CART_ADD':
            return {
                ...state,
                cart: { items: [...(state.cart?.items || []), action.payload] },
            };

        case 'CART_REMOVE':
            return {
                ...state,
                cart: { items: (state.cart?.items || []).filter((i) => i.key !== action.payload) },
            };

        case 'CART_CLEAR':
            return {
                ...state,
                cart: { items: [] },
            };

        default:
            return state;
    }
};
